
export default {
    props: {
        model: {
            required: false,
            default: 100,
        },
    },
    
}
